import { ID } from '../../utils/codecUtils';
import { QueueRule } from '../models/queueRule';
import { queueRuleSchema } from '../models/queueRule.schema';
import { rulePatchPayloadSchema } from './patch.schema';

export type RulePatchPayload = Partial<QueueRule>;

export const patch = (ruleId: ID, payload: RulePatchPayload) => {
  return {
    endpoint: `/rules/${ruleId}`,
    method: 'PATCH',
    responseSchema: queueRuleSchema,
    payloadSchema: rulePatchPayloadSchema,
    payload,
  } as const;
};
